import { TranslationParams, TranslationService } from '../../services/translation.service';

/**
 * Billing copy for strings built in TypeScript (AB#17492). Templates use the
 * translate pipe; computed labels call this through a component's t() helper.
 *
 * Returns the catalog text once en.json has loaded. Until then, or without a
 * TranslationService, it returns the English fallback with its {{placeholders}}
 * filled, so English users never see a raw billing.* key.
 */
export function billingText(
  translations: Pick<TranslationService, 'getTranslation'> | null | undefined,
  key: string,
  fallback: string,
  params?: TranslationParams
): string {
  const value = translations?.getTranslation(key, params);
  if (value && value !== key) {
    return value;
  }
  if (!params) {
    return fallback;
  }
  return Object.keys(params).reduce(
    (text, param) => text.replace(new RegExp(`\\{\\{${param}\\}\\}`, 'g'), () => String(params[param] ?? '')),
    fallback
  );
}

/**
 * A plan tier's display name through the billing.currentPlan.tiers.* keys
 * (Foundation / Professional / Business). An unknown tier shows `fallback`,
 * which callers set to what they showed before.
 */
export function billingTierName(
  translations: Pick<TranslationService, 'getTranslation'> | null | undefined,
  tier: string,
  fallback: string
): string {
  switch (tier) {
    case 'FOUNDATION':
      return billingText(translations, 'billing.currentPlan.tiers.foundation', 'Foundation');
    case 'PROFESSIONAL':
      return billingText(translations, 'billing.currentPlan.tiers.professional', 'Professional');
    case 'BUSINESS':
      return billingText(translations, 'billing.currentPlan.tiers.business', 'Business');
    default:
      return fallback;
  }
}
